import {combineReducers} from 'redux';

import {communicationReducer} from './communication';
import {IRequestNewMailConfirmationState} from '../types';

export const mailConfirmationReducer = combineReducers<IRequestNewMailConfirmationState>({
  communications: communicationReducer
});
